__turbopack_context__.v({
  "authBox": "_LoginRedirect-module-scss-module__Ps8xcq__authBox",
  "brand": "_LoginRedirect-module-scss-module__Ps8xcq__brand",
  "brandLockupLink": "_LoginRedirect-module-scss-module__Ps8xcq__brandLockupLink",
  "brandLockupSvg": "_LoginRedirect-module-scss-module__Ps8xcq__brandLockupSvg",
  "brandMotto": "_LoginRedirect-module-scss-module__Ps8xcq__brandMotto",
  "brandMottoLine": "_LoginRedirect-module-scss-module__Ps8xcq__brandMottoLine",
  "card": "_LoginRedirect-module-scss-module__Ps8xcq__card",
  "cardBody": "_LoginRedirect-module-scss-module__Ps8xcq__cardBody",
  "colForm": "_LoginRedirect-module-scss-module__Ps8xcq__colForm",
  "colSide": "_LoginRedirect-module-scss-module__Ps8xcq__colSide",
  "continueBtn": "_LoginRedirect-module-scss-module__Ps8xcq__continueBtn",
  "divider": "_LoginRedirect-module-scss-module__Ps8xcq__divider",
  "error": "_LoginRedirect-module-scss-module__Ps8xcq__error",
  "footer": "_LoginRedirect-module-scss-module__Ps8xcq__footer",
  "form": "_LoginRedirect-module-scss-module__Ps8xcq__form",
  "googleBtn": "_LoginRedirect-module-scss-module__Ps8xcq__googleBtn",
  "inner": "_LoginRedirect-module-scss-module__Ps8xcq__inner",
  "input": "_LoginRedirect-module-scss-module__Ps8xcq__input",
  "page": "_LoginRedirect-module-scss-module__Ps8xcq__page",
  "row": "_LoginRedirect-module-scss-module__Ps8xcq__row",
  "sideImage": "_LoginRedirect-module-scss-module__Ps8xcq__sideImage",
  "sidePanel": "_LoginRedirect-module-scss-module__Ps8xcq__sidePanel",
  "subtitle": "_LoginRedirect-module-scss-module__Ps8xcq__subtitle",
  "title": "_LoginRedirect-module-scss-module__Ps8xcq__title",
});
